import { Flex } from 'antd';
import styles from './business-hours-legend.module.scss';
import { useTranslation } from 'react-i18next';

export function BusinessHoursLegend() {
  const { t } = useTranslation('businessHours');

  return (
    <Flex gap={16} className={styles.legend}>
      <Flex align="center" gap={6}>
        <div className={styles.legendDotPermanent} />
        <span>{t('legend.permanent')}</span>
      </Flex>
      <Flex align="center" gap={6}>
        <div className={styles.legendDotTemporary} />
        <span>{t('legend.temporary')}</span>
      </Flex>
      <Flex align="center" gap={6}>
        <div className={styles.legendDotClosed} />
        <span>{t('closed')}</span>
      </Flex>
    </Flex>
  );
}
